import { KnowledgeBasesV2Service } from "@/generated";
import { useSpotUser } from "@/utils/spotUser";
import { DATA_KEYS } from "@/utils/useRemoteData";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SpotToast } from "../SpotToast";
import { NoxusIconPicker } from "../Flows/NoxusIconPicker";
import { SIZE_MAP } from "../UI/NoxusIcon";

export const KBIconPicker = ({
  kbId,
  icon = "kb",
  size = "md",
  side = "right",
  align = "end",
  disabled = false,
}: {
  kbId: string;
  icon?: string;
  size?: keyof typeof SIZE_MAP;
  side?: "left" | "right" | "bottom" | "top";
  align?: "start" | "end";
  disabled?: boolean;
}) => {
  const queryClient = useQueryClient();
  const { spotGroup } = useSpotUser();

  const editKBMutation = useMutation({
    mutationFn: KnowledgeBasesV2Service.updateKnowledgeBaseV2,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DATA_KEYS.KNOWLEDGE_BASES_V2_ID],
      });
      queryClient.invalidateQueries({
        queryKey: [DATA_KEYS.KNOWLEDGE_BASES_V2],
      });
    },
    onError: () => {
      SpotToast.error("Error updating icon");
    },
  });

  const handleIconClick = (icon: string) => {
    editKBMutation.mutate({
      path: {
        knowledge_base_id: kbId,
        group_id: spotGroup.id,
      },
      body: {
        meta: {
          icon,
        },
      },
    });
  };

  return (
    <NoxusIconPicker
      icon={icon}
      handleClick={handleIconClick}
      size={size}
      disabled={disabled}
      side={side}
      align={align}
    />
  );
};
